import Storage from '@/lib/Storage'
import { isEmpty } from '@/utils/isEmpty'

export const renderCsv = (csv: string, filename?: string) => {
  const url = window.URL.createObjectURL(new Blob([String(csv)]))
  const link = document.createElement('a')
  const fileName = filename || generateCsvFileName()

  link.href = url
  link.setAttribute('download', fileName)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

const generateCsvFileName = () => {
  const role = Storage().getActiveRole()

  if (isEmpty(role)) return 'order_batch.csv'

  const vendorName = role.subname.replace(/\s+/g, '_').toLowerCase()

  return `${vendorName}_order_batch.csv`
}
